export default __webpack_public_path__ + "static/regulus_me-330676a97ad04042b4b0e1ca0775955f.jpg";